/** Синхронизировать с api/app/core/privacy_policy.py (PRIVACY_POLICY_VERSION). */
export const PRIVACY_POLICY_VERSION = '2026-04-01';
